"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/styles");
var react_1 = __importStar(require("react"));
var createCustomThemeByColors_1 = __importDefault(require("../lib/createCustomThemeByColors"));
var fn_1 = require("../lib/fn");
var config_1 = require("./config");
var DecoratorWrapper = function (_a) {
    var _b = _a.defaultTheme, defaultTheme = _b === void 0 ? core_1.createMuiTheme() : _b, children = _a.children;
    var _c = react_1.useState({}), themeColors = _c[0], setThemeColors = _c[1];
    var handleSetThemeColorsFromPanel = react_1.useCallback(function (mes) {
        setThemeColors(mes.themeColors);
    }, []);
    react_1.useEffect(function () {
        fn_1.connectToChannelAndDisconnect(config_1.EVENT_SET_THEME, handleSetThemeColorsFromPanel);
    }, []);
    var customTheme = createCustomThemeByColors_1.default(defaultTheme, themeColors);
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: customTheme }, children));
};
exports.default = DecoratorWrapper;
